import { Box, Button, Group, PasswordInput, Stack, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { changePassword } from "api/auth.service";
import { safeApiCall } from "api/common.service";
import {
  MantineNotificationColor,
  MantineNotificationPosition,
} from "common/constants";
import React, { useState } from "react";
import { ChangePassword } from "types/interface.types";

const ChangePasswordPage: React.FC = () => {
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");

  // Define our useForm and must be declared before any UseEffects
  const form = useForm<ChangePassword>({
    initialValues: {
      oldPassword: "",
      newPassword: "",
    },

    validate: {
      oldPassword: (value) => (value ? null : "Enter your current password"),
      newPassword: (value) =>
        value.length < 8 ? "New password must be at least 8 characters" : null,
    },
  });

  const handleSubmit = async (values: ChangePassword) => {
    setStatus("loading");
    try {
      await safeApiCall(changePassword(values));
      notifications.show({
        title: `Password Management`,
        message: "Password changed successfully! 🌟",
        position: MantineNotificationPosition.TopCenter,
        color: MantineNotificationColor.Success,
      });
      setStatus("success");
      form.reset();
    } catch (error) {
      notifications.show({
        title: `Password Management`,
        message: "Failed to change password. Please try again.",
        position: MantineNotificationPosition.TopCenter,
        color: MantineNotificationColor.Error,
      });
      setStatus("error");
    }
  };

  return (
    <Box>
      <Stack>
        <Title order={2}>Change Password</Title>

        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Stack>
            <PasswordInput
              label="Current Password"
              placeholder="Enter current password"
              {...form.getInputProps("oldPassword")}
            />

            <PasswordInput
              label="New Password"
              placeholder="Enter new password"
              {...form.getInputProps("newPassword")}
            />

            <Group justify="flex-end">
              <Button type="submit" loading={status === "loading"}>
                Update Password
              </Button>
            </Group>
          </Stack>
        </form>
      </Stack>
    </Box>
  );
};

export default ChangePasswordPage;
